import {
  type PrequalQuestionnaire,
  type QuestionType,
  QuestionnaireInputType,
} from '@avalara/types/prequal-questionnaire';
import type { QuestionnaireState } from '@avalara/types/reducer-states';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: QuestionnaireState = {
  config: null,
  selectedAnswers: {},
  camundaTaskId: null,
};

type SelectAnswerPayload = {
  questionId: string;
  questionType: QuestionnaireInputType;
  answer: string;
};

const store = createSlice({
  name: 'questionnaire',
  initialState,
  reducers: {
    setQuestionConfig: (state, action: PayloadAction<PrequalQuestionnaire>) => {
      state.config = action.payload;
    },
    removeQuestion: (state, action: PayloadAction<string>) => {
      if (state.config) {
        const newQuestions: Array<QuestionType> = state.config.questions.filter(
          (question) => question.id !== action.payload,
        );
        state.config = { ...state.config, questions: newQuestions };
      }
    },
    selectAnswer: (state, action: PayloadAction<SelectAnswerPayload>) => {
      const { questionId, questionType, answer } = action.payload;

      const previousAnswers = state.selectedAnswers[questionId] || [];
      let newAnswers: Array<string> = [];

      if (questionType === QuestionnaireInputType.Radio || answer === 'skipped') {
        // on single-select check or if skipping question, set answers to just selected value or 'skipped'
        newAnswers = [answer];
      } else if (previousAnswers.includes(answer)) {
        // on multi-select un-check, remove selected value from answers
        newAnswers = previousAnswers.filter((existingAnswer) => existingAnswer !== answer);
      } else {
        // on multi-select check, add selected value to answers
        newAnswers = [...previousAnswers, answer];
      }

      state.selectedAnswers = { ...state.selectedAnswers, [questionId]: newAnswers };
    },
    setCamundaTaskId: (state, action: PayloadAction<string>) => {
      state.camundaTaskId = action.payload;
    },
  },
});

export const { setQuestionConfig, removeQuestion, selectAnswer, setCamundaTaskId } = store.actions;

export default store;
